import { useEffect, useState } from "react";
import { X, ArrowLeft, ArrowRight, CheckCircle, MapTrifold } from "@phosphor-icons/react";

export const GuidedTour = ({ open, onClose, steps, navigate }) => {
  const [i, setI] = useState(0);

  useEffect(() => { if (open) setI(0); }, [open]);
  useEffect(() => {
    if (!open) return;
    const s = steps[i];
    if (s && s.to) navigate(s.to);
  }, [open, i]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!open || !steps.length) return null;
  const s = steps[i];
  const last = i === steps.length - 1;

  return (
    <div className="fixed inset-0 z-[60] pointer-events-none">
      <div className="absolute inset-0 bg-black/30 pointer-events-auto" onClick={onClose} />
      <div data-testid="guided-tour" className="pointer-events-auto absolute left-1/2 -translate-x-1/2 bottom-6 w-[92%] max-w-md bg-white rounded-md shadow-xl border border-border p-5 animate-fade-up">
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-center gap-2 text-primary"><MapTrifold size={20} weight="bold" /><span className="overline">Guía · Paso {i + 1} de {steps.length}</span></div>
          <button onClick={onClose} data-testid="tour-close" className="text-muted-foreground hover:text-foreground"><X size={18} /></button>
        </div>
        <h3 className="font-heading font-bold text-lg mt-2">{s.title}</h3>
        <p className="text-sm text-muted-foreground mt-1 leading-relaxed">{s.body}</p>
        <div className="mt-4 flex items-center justify-between">
          <div className="flex gap-1 flex-wrap max-w-[45%]">{steps.map((_, k) => <span key={k} className={`w-1.5 h-1.5 rounded-full ${k === i ? "bg-primary" : "bg-border"}`} />)}</div>
          <div className="flex items-center gap-2">
            {i > 0 && <button onClick={() => setI(i - 1)} data-testid="tour-prev" className="inline-flex items-center gap-1 text-sm font-semibold text-muted-foreground hover:text-foreground px-3 py-1.5"><ArrowLeft size={15} /> Anterior</button>}
            {last
              ? <button onClick={onClose} data-testid="tour-finish" className="inline-flex items-center gap-1.5 text-sm font-semibold bg-primary text-white rounded-sm px-4 py-2 hover:bg-orange-600 transition-colors duration-200"><CheckCircle size={16} weight="fill" /> Terminar</button>
              : <button onClick={() => setI(i + 1)} data-testid="tour-next" className="inline-flex items-center gap-1.5 text-sm font-semibold bg-primary text-white rounded-sm px-4 py-2 hover:bg-orange-600 transition-colors duration-200">Siguiente <ArrowRight size={15} weight="bold" /></button>}
          </div>
        </div>
      </div>
    </div>
  );
};
